import { createTheme } from '@mui/material/styles';

// Design tokens from docs/ui_redesign/apworks-redesign-prototype.html. The CSS variables in redesign.css use the same values.
export const tokens = {
	ink900: '#0A1A2E', ink800: '#0F2744', ink700: '#1C426D', ink600: '#2C5A8F',
	bg: '#F5F7FB', surface: '#FFFFFF', surface2: '#EEF2F7', border: '#E1E7F0', borderStrong: '#CCD6E3',
	text: '#0F172A', text2: '#475569', text3: '#5B6B82', muted: '#66748A',
	accent: '#0891B2', accentStrong: '#0E7490', accentSoft: '#E0F2FE',
	ok: '#15803D', okSoft: '#DCFCE7', warn: '#B45309', warnSoft: '#FEF3C7', bad: '#B91C1C', badSoft: '#FEE2E2',
	fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
	monoFamily: '"IBM Plex Mono", ui-monospace, "SF Mono", Menlo, Consolas, monospace'
};

// Applied only inside the new shell, so Classic keeps MUI's defaults.
const theme = createTheme({
	palette: {
		primary: { main: tokens.ink800, dark: tokens.ink900, light: tokens.ink700, contrastText: '#fff' },
		secondary: { main: tokens.accent, dark: tokens.accentStrong, contrastText: '#fff' },
		success: { main: tokens.ok },
		warning: { main: tokens.warn },
		error: { main: tokens.bad },
		info: { main: tokens.accentStrong },
		background: { default: tokens.bg, paper: tokens.surface },
		text: { primary: tokens.text, secondary: tokens.text2 },
		divider: tokens.border
	},
	typography: {
		fontFamily: tokens.fontFamily,
		fontSize: 13,
		button: { textTransform: 'none', fontWeight: 560 },
		// Page titles on User Groups and Integrations use Typography h4; match the other pages' h1 title.
		h4: { fontSize: 22, fontWeight: 650, letterSpacing: '-0.018em', lineHeight: 1.25 }
	},
	shape: { borderRadius: 6 },
	components: {
		MuiButton: { defaultProps: { disableElevation: true } },
		MuiPaper: { styleOverrides: { rounded: { borderRadius: 10 } } },
		MuiDialog: { styleOverrides: { paper: { borderRadius: 12 } } },
		MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: tokens.ink900, fontSize: 12 } } }
	}
});

export default theme;
